import { defineStore } from 'pinia'
import { stringify, parse } from 'zipson'
import _ from 'lodash'
import { playingType } from 'src/common/constants/index'

interface IState {
  socket: { connected: boolean }
  page: IPageState
  portalVersion: number
  language: string
  orderSound: { playingType: number; sound: string }
  tableColumnLayout: ITableColumnLayout
  // TODO: remove it after responsive
  isNoZoom: boolean
  aiConversations: AIConversation[]
  isChatOpen: boolean
  isTicketOpen: boolean
}

interface AIConversation {
  question: string
  date: string
  id: string
}

interface IPageState {
  layout: { clicked: boolean }
  [key: string]: any
}

interface ITableColumnLayout {
  [key: string]: string[]
}

export const useGeneralStore = defineStore('general', {
  state: (): IState => ({
    socket: { connected: false }, // NOTE: Do not persist socket key because it has to refresh each time browser refreshed.
    /** @type {Record<string, any>} page */
    page: { layout: { clicked: false } },
    portalVersion: NaN,
    language: 'en',
    orderSound: {
      playingType: playingType.ONLY_ONCE,
      sound: 'flute',
    },
    tableColumnLayout: {},
    isNoZoom: false,
    aiConversations: [],
    isChatOpen: false,
    isTicketOpen: false,
  }),
  actions: {
    resetExceptVersion() {
      const latestVersion = this.portalVersion
      this.$reset()
      this.portalVersion = latestVersion
    },
    setPlayingType(playingType: number) {
      this.orderSound.playingType = playingType
    },
    setSoundName(sound: string) {
      this.orderSound.sound = sound
    },
    setIsNoZoom(status: boolean) {
      this.isNoZoom = status
    },
  },
  getters: {},
  persist: {
    key: 'general',
    // paths: ['page', 'portalVersion', 'forgottenLinkLastSentTime'],
    paths: [
      'socket',
      'page',
      'portalVersion',
      'language',
      'orderSound',
      'tableColumnLayout',
      'isNoZoom',
      'aiConversations',
    ],
    serializer: {
      deserialize: parse,
      serialize: stringify,
    },
  },
})
